import getTextWidth from '../../common/getTextWidth';

import design from './design';

const { rolloutTextStyle } = design;

// Allow roughly 20px on each side of the rollout. Don't set this value too low or the text
// might overlap with the dismiss (x) button.
const TEXT_MARGINS = 40;

// This is how we use the available screen width (assuming right-aligned widget, left-to-right):
// [margin min 20px] [rollout max 380px] [margin 10px] [circle button 80px] [margin 10px]
const MINIMUM_SCREEN_MARGINS = 120;

const getMaxRolloutWidth = () => Math.min(window.innerWidth, 500) - MINIMUM_SCREEN_MARGINS;

/**
 * Returns appropriate rollout width for given text and current browser width
 */
const calculateWidth = text => {
  const width = Math.ceil(
    getTextWidth(text, {
      family: 'Arial, sans-serif',
      weight: rolloutTextStyle['font-weight'],
      size: rolloutTextStyle['font-size'],
    })
  );
  const maxRolloutWidth = getMaxRolloutWidth();
  const maxTextWidth = maxRolloutWidth - TEXT_MARGINS;

  // If the text is definitely more than 2 lines long, just use the max possible width
  if (width > 2 * maxTextWidth) return maxRolloutWidth;

  // If the text can fit in 1 line, simply adjust the width to the text
  if (width <= maxTextWidth) return width + TEXT_MARGINS;

  // Otherwise, the text could fit in 2 lines, so let's try to make them roughly equal width. Note
  // that we don't know how the text will be broken, so this may not be helping in some cases.
  return Math.min(width / 2 + TEXT_MARGINS + 30, maxRolloutWidth);
};

export default calculateWidth;
